<template>
<!--  -->
<div class="tableSys vaM_E">
	<div>
		<InputText v-model="code" :addClass="'sizeL'" :only="'verificationCode'" :maxLength="6" :verification="'notEmpty'" :fillText="$t('word26',['验证码'])" :errorTip="errorTip" ref="inputText"></InputText>
	</div>
	<div class="w12x pl1x">
		<button class="w100pct functionBtn sizeL" :class="{disable:!canSend||lock.verifiCode}" @click="getCode" type="button">{{display}}</button>
	</div>
</div>
</template>
<script>
import InputText from '@/components/common/ui/InputText';

import {getLanguageStr} from '@/util/language.js';
import * as lib from '@/util/lib.js';

import {apiGetVerificationCode} from '@/api/login.js';
export default{
	// name:"",
	components: {InputText},
	props: {
		value: {
			type: [String, Number],
			default: ''
		},
		target: {
			type: [String, Number],
			default: ''
		},
		type: {
			type: String,
			default: ''// eMail,mobile
		},
		action: {
			type: String,
			default: ''// 注册：reg，重置密码：reset_pwd，绑定：bind
		},
		errorTip: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			code: this.value,

			lock: {verifiCode: false},
			time: {instance: null, last: -1, max: 60}// 倒计时
		};
	},
	watch: {
		code: function (value) {
			this.$emit('input', value);
		}
		// target:function(){
		// 	this.canSend();
		// }
	},
	methods: {
		reset: function () {
			this.code = '';
			this.time.last = -1;
			this.$refs.inputText.reset();
		},
		startTime: function () {
			clearInterval(this.time.instance);
			this.time.last = this.time.max;
			this.time.instance = setInterval(() => {
				if (this.time.last >= 0) --this.time.last;
				else {
					this.lock.verifiCode = false;
					clearInterval(this.time.instance);
				}
			}, 1000);
		},
		getCode: function () {
			switch (this.type) {
			case 'eMail':
			case 'mobile':
				this.lock.verifiCode = true;
				apiGetVerificationCode(this.target, this.action, this.type).then(success => {
					this.startTime();
				}, error => {
					this.lock.verifiCode = false;
					this.$emit('Error', error);
				});
				break;
			}
		}
		// doVerification:function(){
		// 	let optionArray=this.verification.split(",");
		// 	let $this=this;
		// 	$.each(optionArray,function(){
		// 		let option=this.split(":");
		// 		switch(option[0]){
		// 			case "notEmpty":
		// 				if(lib.validValue($this.text,["empty"]).allClear) {$this.error=getLanguageStr("phrase3","不能为空");return false;}
		// 				else $this.error=$this.errorTip;
		// 				break;
		// 			case "isMobile":
		// 				if(lib.validValue($this.text,["notMobile"]).allClear) {$this.error=getLanguageStr("phrase19","手机号格式错误");return false;}
		// 				else $this.error=$this.errorTip;
		// 				break;
		// 			case "isEmail":
		// 				if(lib.validValue($this.text,["notEmail"]).allClear) {$this.error=getLanguageStr("phrase18","邮箱格式错误");return false;}
		// 				else $this.error=$this.errorTip;
		// 				break;
		// 			case "isEmailOrMobile":
		// 				if(lib.validValue($this.text,["notEmail"]).allClear && lib.validValue($this.text,["notMobile"]).allClear) {$this.error=getLanguageStr("phrase20","邮箱或手机号格式错误");return false;}
		// 				else $this.error=$this.errorTip;
		// 				break;
		// 			case "isUsername":
		// 				// if(lib.validValue($this.text,["notUsername"]).allClear) {$this.error=getLanguageStr("phrase18","用户名格式错误");return false;}
		// 				// else $this.error=$this.errorTip;
		// 				break;
		// 		}
		// 	})

		// 	if(this.error) return false;//验证不通过：false
		// 	else return true;//验证通过：true
		// }
	},
	computed: {
		display: function () {
			if (this.time.last >= 0) return this.time.last + getLanguageStr('unit47', '秒');
			else return getLanguageStr('phrase82', '发送验证码');
		},
		canSend: function () { // 发送验证
			let out = false;
			switch (this.type) {
			case 'eMail':
				out = lib.validValue(this.target, ['email']).allClear;
				break;
			case 'mobile':
				if (this.target.length >= 7) out = true;
				break;
			}
			// this.lock.verifiCode=out;
			return out;
		}
	},
	created () {},
	mounted () {}
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ui/VerificationCode.vue